import script from "./presell.vue?vue&type=script&setup=true&lang=js"
export * from "./presell.vue?vue&type=script&setup=true&lang=js"

import "./presell.vue?vue&type=style&index=0&id=84bfacdc&lang=scss&scoped=true"

import exportComponent from "/Users/luoxuelin/Workspace/idea/wnzhfc/s-pages/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84bfacdc"]])

export default __exports__